// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__36Ons","tableContainer":"styles_tableContainer__3lSN5","giniIndexInfo":"styles_giniIndexInfo__2EAlE"};